import React, { useState, useEffect } from "react";
import { Table, Row, Col, Card, CardBody, CardTitle, Alert, Label, Input, Badge } from "reactstrap"
import { post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ITEMS_PER_PAGE } from "helpers/pagination_helper";
import Loader from "common/loader";
import { DISTRICTS_SEARCH, LANGUAGES_SEARCH } from "helpers/api_endpoints";
//meta title
document.title = "Districts";
const DistrictList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [name, setName] = useState('');
    const [symbol, setSymbol] = useState('');
    const [status, setStatus] = useState('');
    const [DistrictId, setDistrictId] = useState('');
    const [loading, setLoading] = useState(true);
    const [districts, setDistricts] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [filters, setFilters] = useState({});
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [successMsg, setsuccessMsg] = useState('');

    useEffect(() => {
        successMessage();
        post(`${DISTRICTS_SEARCH}?paginate=${ITEMS_PER_PAGE}&page=${page}`, filters)
            .then(response => {
                const data = response.data;

                setDistricts(data.data);
                setTotalPages(data.pagination.totalPages);
                setTotalItems(data.pagination.totalItems);
                setPage(data.pagination.currentPage);
                setLoading(false);
            })
            .catch(error => {
                if (error.response.status == 400) {
                    navigate('/logout');
                }
            })
    }, [page, filters, languages]);

    useEffect(() => {
        post(`${LANGUAGES_SEARCH}`, filters)
            .then(response => {
                const data = response.data;
                setLanguages(data);
                setLoading(false);
            })
            .catch(error => {
                console.log(error)
                // if (error.response.status == 400) {
                //     navigate('/logout');
                // }
            })
    }, []);

    const successMessage = () => {
        if (location.state) {
            setsuccessMsg(location.state.successMsg);
            setTimeout(() => {
                location.state.successMessage = '';
                setsuccessMsg('');
            }, 4000)
        }
    };

    const handleFilter = (type, value) => {
        const filtvalues = {};
        if (value) {
            switch (type) {
                case 'name':
                    setName(value);
                    filtvalues.name = value;
                    break;
                case 'status':
                    setStatus(value);
                    filtvalues.status = value;
                    break;
                case 'cityName':
                    filtvalues.cityName = value;
                    break;
                default:
                    break;
            }
        }
        setFilters(filtvalues);
    }

    const handlePrevPage = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };

    const handleNextPage = () => {
        if (page < totalPages) {
            setPage(page + 1);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Home" breadcrumbItem="Districts" />
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <br></br>
                                {successMsg ? <Alert style={{ margin: "25px" }} color="success">{successMsg}</Alert> : null}
                                <CardTitle>
                                    <Link to="/districts/add" >
                                        <button style={{ float: "right", marginRight: "20px" }} className="btn btn-sm btn-primary"><i className="dripicons-plus"></i> &nbsp;<Trans>Create</Trans></button>
                                    </Link>
                                </CardTitle>

                                <div style={{ margin: "25px" }}>
                                    <div className="row">
                                        <div className="form-group col-md-3 mt-2">
                                            <Label className="form-label"><Trans>Name</Trans></Label>
                                            <Input
                                                name="name"
                                                className="form-control"
                                                placeholder=""
                                                type="text"
                                                onChange={(e) => handleFilter('name', e.target.value)}
                                                onKeyDown={(e) => handleFilter('name', e.target.value)}
                                            ></Input>
                                        </div>
                                        <div className="form-group col-md-3 mt-2">
                                            <Label className="form-label"><Trans>City Name</Trans></Label>
                                            <Input
                                                name="cityName"
                                                className="form-control"
                                                placeholder=""
                                                type="text"
                                                onChange={(e) => handleFilter('cityName', e.target.value)}
                                                onKeyDown={(e) => handleFilter('cityName', e.target.value)}
                                            ></Input>
                                        </div>
                                        <div className="form-group col-md-3 mt-2">
                                            <Label className="form-label"><Trans>Status</Trans></Label>
                                            <select name="status" value={status} className="form-control" onChange={(e) => handleFilter('status', e.target.value)}>
                                                <option value=''></option>
                                                <option value={1} ><Trans>Active</Trans></option>
                                                <option value={0} ><Trans>Non Active</Trans></option>
                                            </select>
                                        </div>
                                    </div>
                                </div>


                                <CardBody>
                                    <div className="table-responsive">
                                        <Table className="table table-striped table-bordered mb-0">
                                            <thead>
                                                <tr>
                                                    <th><Trans>ID</Trans></th>
                                                    <th><Trans>Name</Trans></th>
                                                    <th><Trans>Symbol</Trans></th>
                                                    <th><Trans>City</Trans></th>
                                                    <th><Trans>Status</Trans></th>
                                                    <th>#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading ? <tr><th colSpan={6} className="text-center"><Loader></Loader></th></tr> : null}
                                                {
                                                    districts.map((district, index) => (
                                                        <tr key={index}>
                                                            <td>{district.id}</td>
                                                            <td>{district.named && district.named.title?district.named.title.map((c, i)=>(<p key={i}>{Object.values(c)}</p>)):district.name}</td>
                                                            <td>{district.symbol}</td>
                                                            <td>{district.city && district.city.named.title?district.city.named.title.map((c, i)=>(<p key={i}>{Object.values(c)}</p>)):''}</td>
                                                            <td>{(district.status == 1) ? <Badge className="bg-success"><Trans>Active</Trans></Badge> : null}</td>
                                                            <td><Link to={`/districts/edit/${district.id}`}><button className="btn btn-sm btn-info"><i className="dripicons-pencil"></i> &nbsp;<Trans>Edit</Trans></button></Link> &nbsp;
                                                                <Link to={`/districts/remove/${district.id}`}><button className="btn btn-sm btn-danger" ><i className="dripicons-trash"></i> &nbsp;<Trans>Remove</Trans> </button></Link>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                    <br></br>
                                    <div className="text-center">
                                        {/* Pagination controls */}
                                        <button className="btn btn-sm btn-dark" onClick={handlePrevPage} disabled={page === 1}>
                                            <Trans>Previous</Trans>
                                        </button>&nbsp;
                                        <button className="btn btn-sm btn-dark" onClick={handleNextPage} disabled={page === totalPages}>
                                            <Trans>Next</Trans>
                                        </button>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment >
    )
}

export default DistrictList
